module.exports = __webpack_public_path__ + "static/media/esia-logo.7707e1bd.svg";